import type {
  AttachmentsRequest,
  AttachmentsSearchRequest,
} from '@trukt/tms-api/AttachmentServices';
import { createKey } from './createKey';

const keyHandler = createKey('attachment');

export const AttachmentServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<AttachmentsSearchRequest>(),
  getById: keyHandler.createMethod(),
  get: keyHandler.createMethod<AttachmentsRequest>(),
};
